import {
  Autocomplete,
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import React, { useEffect, useMemo, useState, useRef } from "react";
import { useSelector } from "react-redux";
import {
  ERP_LABEL_ADD_PAYMENT_REQUEST,
  ERP_LABEL_CANCEL,
  HMS_PAYMENT_REUQEST_STATUS,
  HMS_PAYMENT_REUQEST_TYPE,
  PATIENT_VISIT_TYPE,
} from "../../../core/constants/erpConstants";
import {
  getActiveVisitLists,
  savePaymentRequests,
} from "../ERPActions/erpActions";
import { Close, PaymentTwoTone } from "@mui/icons-material";
import { helperServices } from "../../../shared/helper";
import { Add } from "@material-ui/icons";

const AddHMSPaymentRequest = ({
  patientId,
  visitId,
  closeHMSAddPaymentRequest,
}) => {
  const dropdownRef = useRef(null);
  const [patient, setPatient] = useState("");
  const [paymentRequest, setPaymentRequest] = useState({});
  const [amount, setAmount] = useState("");
  const [isSearchEdit, setIsSearchEdit] = useState(false);

  const patientInfo = useSelector(
    (state) => state.patientDetailsState.patientBasic
  );

  const [patientList, setPatientList] = useState([]);
  const [search, setSearch] = useState("");
  const [filteredPatients, setFilteredPatients] = useState([]);
  const [hideResults, setHideResults] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(-1);

  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setHideResults(true); // Hide dropdown on outside click
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handlePaymentRequestChange = (key, value) => {
    console.log("handlePaymentRequestChange: ", key, value);
    setPaymentRequest((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  const handleAddPaymentRequestMethod = async () => {
    console.log("handleAddPaymentRequest: ", paymentRequest);
    if (HMS_PAYMENT_REUQEST_TYPE.REFUND_REQUEST === paymentRequest.type) {
      paymentRequest.requestedAmount = -paymentRequest.requestedAmount;
    }
    if (patientId && visitId) {
      const savePaymentReq = await savePaymentRequests(
        patientId,
        visitId,
        paymentRequest
      );
      if (savePaymentReq) {
        closeHMSAddPaymentRequest(false);
      }
    } else if (
      paymentRequest &&
      paymentRequest.patientId &&
      paymentRequest.visitId
    ) {
      const savePaymentReq = await savePaymentRequests(
        paymentRequest.patientId,
        paymentRequest.visitId,
        paymentRequest
      );
      if (savePaymentReq) {
        closeHMSAddPaymentRequest(false);
      }
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // if (paymentRequest) {
    //   alert(`Please fill all fields : ${paymentRequest}`);
    //   return;
    // }
    // alert(`Patient: ${patient}, Amount: ₹${amount} ${paymentRequest}`);
    handleAddPaymentRequestMethod();
    // setPatient("");
    // setAmount("");
  };

  const getPatientList = async () => {
    let data = {
      patientType: PATIENT_VISIT_TYPE.INPATIENT,
      // 'patientName': '',
    };
    const visitList = await getActiveVisitLists(data);
    console.log("getPatientList: ", visitList);
    if (visitList && visitList.patient && visitList.patient.length > 0) {
      setPatientList(visitList.patient);
    } else {
      setPatientList([]);
    }
  };
  // const defaultProps = useMemo(() => ({
  //   options: patientList,
  //   getOptionLabel: (option) => option.fullName,
  // }), [patientList]);

  useEffect(() => {
    let loggedINUserID = helperServices.getLoggedUserGVID();
    let loggedINUserName = helperServices.getLoggedUserName();
    console.log("patID:visitId ::", patientId, visitId);
    if (patientId && visitId) {
      setIsSearchEdit(true);
      setPatient(patientInfo);

      // THIS LINE FIXES THE PROBLEM
      setSearch(`${patientInfo.id} - ${patientInfo.fullName}`);

      setPatientList([patientInfo]);
      setHideResults(true);
      setSelectedIndex(-1);

      setPaymentRequest((prev) => ({
        ...prev,
        patientId: patientInfo.id,
        visitId: patientInfo.visitId,
        requestedById: loggedINUserID,
        requestedByName: loggedINUserName,
        cby: loggedINUserID,
        uby: loggedINUserID,
        type: HMS_PAYMENT_REUQEST_TYPE.ADVANCE_REQUEST,
        status: HMS_PAYMENT_REUQEST_STATUS.PAYMENT_REQUEST_REQUESTED,
      }));
    } else {
      setIsSearchEdit(false);
      setPaymentRequest((prev) => ({
        ...prev,
        requestedById: loggedINUserID,
        requestedByName: loggedINUserName,
        cby: loggedINUserID,
        uby: loggedINUserID,
        type: HMS_PAYMENT_REUQEST_TYPE.ADVANCE_REQUEST,
        status: HMS_PAYMENT_REUQEST_STATUS.PAYMENT_REQUEST_REQUESTED,
      }));
      getPatientList();
    }
  }, []);

  useEffect(() => {
    console.log(
      "useeffect: Addhmspaymentrequest: ",
      isSearchEdit,
      patient,
      patientList
    );
  }, [isSearchEdit, patient, patientList]);

  return (
    // <div style={{
    //   // maxWidth: "600px",
    //   margin: "30px auto", display: "inline-block", marginInlineStart: "12.5px"
    // }}>
    //   <h2>Add Payment Request</h2>
    //   <form onSubmit={handleSubmit}>
    //     {/* Flex Row */}
    //     <div
    //       style={{
    //         display: "flex",
    //         gap: "20px",
    //         flexWrap: "wrap", // makes it stack vertically on small screens
    //         marginBottom: "20px",
    //         marginTop: "20px",
    //         // marginLeft: "15px"
    //       }}
    //     >
    //       {/* Patient Name */}
    //       <div style={{
    //         flex: 1,
    //         // minWidth: "250px"
    //       }}>
    //         {/* <label style={{ display: "block", marginBottom: "6px" }}>
    //           Patient Name
    //         </label> */}
    //         <Autocomplete
    //           id="Person-Name"
    //           disablePortal
    //           onChange={(event, newValue) => {
    //             console.log("select option add hms payment: ", newValue);
    //             if (!newValue || (newValue && !newValue.id)) return;
    //             setPatient(newValue);
    //             handlePaymentRequestChange('patientId', newValue.id);
    //             handlePaymentRequestChange('visitId', newValue.visit.id);
    //             handlePaymentRequestChange('patientName', newValue.fullName);
    //           }}
    //           options={patientList ? patientList : []}
    //           getOptionLabel={(option) => option && option.id ? `${option.id} - ${option.fullName}` : ""}
    //           // getOptionLabel={(option) => option.fullName}
    //           getOptionDisabled={() => isSearchEdit}
    //           disableClearable={isSearchEdit}
    //           disabled={isSearchEdit}
    //           sx={{ width: 300 }}
    //           value={patient}
    //           renderInput={(params) => <TextField {...params} label="Patient Name" />}
    //         />
    //         {/* <Autocomplete
    //           // {...defaultProps}
    //           id="Person-Name"
    //           onChange={(event, newValue) => {
    //             console.log("select option add hms payment: ", newValue);
    //             if(!newValue || (newValue && !newValue.id)) return;
    //             setPatient(newValue);
    //             handlePaymentRequestChange('patientId', newValue.id);
    //             handlePaymentRequestChange('visitId', newValue.visit.id);
    //             handlePaymentRequestChange('patientName', newValue.fullName);
    //           }}
    //           options={patientList ? patientList : []}
    //           getOptionLabel={(option) => option && option.id ? `${option.id} - ${option.fullName}` : "" }
    //           // getOptionLabel={(option) => option.fullName}
    //           getOptionDisabled={() => isSearchEdit}
    //           disableClearable={isSearchEdit}
    //           disabled={isSearchEdit}
    //           // inputValue={inputValue}
    //           // onInputChange={(event, newInputValue) => {
    //           //   setInputValue(newInputValue);
    //           // }}
    //           value={patient}
    //           // disableCloseOnSelect
    //           style={{
    //             width: "100%",
    //             padding: "8px",
    //             borderRadius: "4px",
    //             marginTop: "13px",
    //             // border: "1px solid #ccc",
    //           }}
    //           renderInput={(params) => (
    //             <TextField {...params}
    //               // label="Patient Name"
    //               variant="standard" />
    //           )}
    //         /> */}
    //       </div>

    //       {/* Amount */}
    //       {/* <div
    //       // style={{ flex: 1, minWidth: "200px" }}
    //       > */}
    //         {/* <label style={{ display: "block", marginBottom: "14px" }}>
    //           Amount
    //         </label> */}
    //         <TextField
    //           id="Amount"
    //           label="Amount"
    //           variant="outlined"
    //           placeholder="Enter amount"
    //           value={paymentRequest.requestedAmount}
    //           required
    //           onChange={(e) => {
    //             // setAmount(e.target.value);
    //             handlePaymentRequestChange('requestedAmount', e.target.value);
    //           }}
    //         />
    //         {/* <input
    //           type="number"
    //           value={paymentRequest.requestedAmount}
    //           onChange={(e) => {
    //             // setAmount(e.target.value);
    //             handlePaymentRequestChange('requestedAmount', e.target.value);
    //           }}
    //           placeholder="Enter amount"
    //           style={{
    //             width: "100%",
    //             padding: "8px",
    //             borderRadius: "4px",
    //             border: "1px solid #ccc",
    //           }}
    //           required
    //         /> */}
    //       {/* </div> */}

    //       {/* <div> */}
    //         {/* <label style={{ display: "block", marginBottom: "14px" }}>
    //           Request Type
    //         </label> */}
    //         {/* <select
    //           // disabled={isSearchEdit}
    //           value={paymentRequest.type}
    //           onChange={(e) => handlePaymentRequestChange("type", e.target.value)}
    //           style={{
    //             width: "100%",
    //             padding: "8px",
    //             borderRadius: "4px",
    //             border: "1px solid #ccc",
    //           }}
    //           required
    //         >
    //           <option value="">Select Payment Request Type </option>
    //           <option value={HMS_PAYMENT_REUQEST_TYPE.ADVANCE_REQUEST}>{HMS_PAYMENT_REUQEST_TYPE.ADVANCE_REQUEST}</option>
    //           <option value={HMS_PAYMENT_REUQEST_TYPE.REFUND_REQUEST}>{HMS_PAYMENT_REUQEST_TYPE.REFUND_REQUEST}</option>
    //         </select> */}
    //         {/* <InputLabel id="request-type-simple-select">Request Type</InputLabel> */}
    //         <Select
    //           labelId="request-type-select"
    //           id="request-type-simple-select"
    //           value={paymentRequest.type}
    //           label="Request Type"
    //           onChange={(e) => handlePaymentRequestChange("type", e.target.value)}
    //         >
    //           <MenuItem value={HMS_PAYMENT_REUQEST_TYPE.ADVANCE_REQUEST}>{HMS_PAYMENT_REUQEST_TYPE.ADVANCE_REQUEST}</MenuItem>
    //           <MenuItem value={HMS_PAYMENT_REUQEST_TYPE.REFUND_REQUEST}>{HMS_PAYMENT_REUQEST_TYPE.REFUND_REQUEST}</MenuItem>
    //         </Select>
    //       {/* </div> */}

    //       {/* Submit Button */}
    //       <div className="d-inline-flex gap-2"
    //         // style={{ placeContent: "flex-end", rowGap: "10px"}}
    //         style={{ paddingTop: "38px" }}
    //       >
    //         <Button
    //           type="submit"
    //           variant="contained"
    //           className="billingBlueButton"
    //           startIcon={<Add />}
    //         // color="primary"
    //         // onClick={()=>handleSubmit}
    //         >
    //           {/* {ERP_LABEL_ADD_PAYMENT_REQUEST} */}
    //         </Button>
    //         <Button
    //           type="button"
    //           variant="contained"
    //           className='billingCancelButton'
    //           sx={{
    //             backgroundColor: "#FF0000 !important",
    //           }}
    //           // style={{backgroundColor:" #FF0000 !important"}}
    //           // color="error"
    //           startIcon={<Close />}
    //           onClick={() => closeHMSAddPaymentRequest(false)}
    //         >
    //           {ERP_LABEL_CANCEL}
    //         </Button>

    //       </div>
    //     </div>

    //   </form>
    // </div>

    // <div style={{
    //   maxWidth: "600px",
    //   margin: "30px 0",
    // }}>
    //   <h2>Add Payment Request</h2>

    //   <form onSubmit={handleSubmit}>
    //     {/* Form Fields Row - All in one line, same height */}
    //     <div style={{
    //       display: "flex",
    //       gap: "16px",
    //       flexWrap: "wrap", // Keeps responsive; remove if you NEVER want wrap
    //       alignItems: "flex-start", // Aligns tops (better with labels)
    //       marginBottom: "20px"
    //     }}>
    //       {/* Patient Name */}
    //       <div style={{ flex: 1, minWidth: "200px" }}>
    //         <Autocomplete
    //           id="Person-Name"
    //           disablePortal
    //           onChange={(event, newValue) => {
    //             if (!newValue || !newValue.id) return;
    //             setPatient(newValue);
    //             handlePaymentRequestChange('patientId', newValue.id);
    //             handlePaymentRequestChange('visitId', newValue.visit.id);
    //             handlePaymentRequestChange('patientName', newValue.fullName);
    //           }}
    //           options={patientList || []}
    //           getOptionLabel={(option) => (option?.id ? `${option.id} - ${option.fullName}` : "")}
    //           getOptionDisabled={() => isSearchEdit}
    //           disableClearable={isSearchEdit}
    //           disabled={isSearchEdit}
    //           value={patient}
    //           renderInput={(params) => (
    //             <TextField
    //               {...params}
    //               label="Patient Name"
    //               variant="outlined"
    //               fullWidth
    //             />
    //           )}
    //         />
    //       </div>

    //       {/* Amount */}
    //       <div style={{ flex: 1, minWidth: "140px" }}>
    //         <TextField
    //           label="Amount"
    //           variant="outlined"
    //           type="number"
    //           sx={{ height: '60px' }}
    //           inputProps={{ min: 0, step: "any" }}
    //           value={paymentRequest.requestedAmount}
    //           onChange={(e) => handlePaymentRequestChange('requestedAmount', e.target.value)}
    //           fullWidth
    //           required
    //         />
    //       </div>

    //       {/* Request Type */}
    //       <div style={{ flex: 1, minWidth: "160px" }}>
    //         <FormControl variant="outlined" sx={{ height: '60px' }} fullWidth>
    //           <InputLabel id="request-type-select-label">Request Type</InputLabel>
    //           <Select
    //             labelId="request-type-select-label"
    //             sx={{ height: '60px' }}
    //             value={paymentRequest.type}
    //             label="Request Type"
    //             onChange={(e) => handlePaymentRequestChange("type", e.target.value)}
    //             required
    //           >
    //             <MenuItem value={HMS_PAYMENT_REUQEST_TYPE.ADVANCE_REQUEST}>
    //               {HMS_PAYMENT_REUQEST_TYPE.ADVANCE_REQUEST}
    //             </MenuItem>
    //             <MenuItem value={HMS_PAYMENT_REUQEST_TYPE.REFUND_REQUEST}>
    //               {HMS_PAYMENT_REUQEST_TYPE.REFUND_REQUEST}
    //             </MenuItem>
    //           </Select>
    //         </FormControl>
    //       </div>
    //       {/* Buttons */}
    //       <div
    //       style={{ flex: 1}}
    //       // style={{
    //       //   display: "flex",
    //       //   justifyContent: "flex-end",
    //       //   gap: "12px"
    //       // }}
    //       >
    //         <Button type="submit" variant="contained" startIcon={<Add />}>
    //           Add
    //         </Button>
    //         <Button
    //           type="button"
    //           variant="contained"
    //           sx={{ backgroundColor: "#FF0000 !important" }}
    //           startIcon={<Close />}
    //           onClick={() => closeHMSAddPaymentRequest(false)}
    //         >
    //           {ERP_LABEL_CANCEL}
    //         </Button>
    //       </div>
    //     </div>

    //   </form>
    // </div>

    <div
      style={{
        marginTop: "30px",
      }}
    >
      <h4>Add Payment Request</h4>

      <form onSubmit={handleSubmit}>
        {/* Form Fields Row - Same Line, Equal Height */}
        <div
          style={{
            display: "flex",
            gap: "16px",
            flexWrap: "wrap", // Responsive wrap
            alignItems: "flex-start", // Aligns top of labels
            marginBottom: "20px",
            marginTop: "15px",
          }}
        >
          {/* Patient Name */}
          {/* Patient Search Box (Custom like Product Search) */}
          <div
            style={{ flex: 1, minWidth: "200px", position: "relative" }}
            ref={dropdownRef}
          >
            <div className="d-flex flex-column">
              {/* Search Input */}
              <TextField
                label="Patient Name"
                size="small"
                placeholder="Search patient by ID or name..."
                value={search}
                type="search"
                InputProps={{ readOnly: isSearchEdit }} // <-- THIS MAKES IT READONLY
                onChange={(e) => {
                  if (isSearchEdit) return; // prevent editing in edit mode

                  const value = e.target.value;
                  setSearch(value);
                  setSelectedIndex(-1);

                  if (value.length <= 2) {
                    setFilteredPatients([]);
                    setHideResults(true);
                    return;
                  }

                  const filtered = patientList.filter((p) =>
                    `${p.id} - ${p.fullName}`
                      .toLowerCase()
                      .includes(value.toLowerCase())
                  );

                  setFilteredPatients(filtered);
                  setHideResults(false);
                }}
                onKeyDown={(e) => {
                  if (isSearchEdit) return; // disable keyboard dropdown in edit mode
                  if (hideResults || filteredPatients.length === 0) return;

                  if (e.key === "ArrowDown") {
                    e.preventDefault();
                    setSelectedIndex((prev) =>
                      prev < filteredPatients.length - 1 ? prev + 1 : 0
                    );
                  }

                  if (e.key === "ArrowUp") {
                    e.preventDefault();
                    setSelectedIndex((prev) =>
                      prev > 0 ? prev - 1 : filteredPatients.length - 1
                    );
                  }

                  if (e.key === "Enter" && selectedIndex >= 0) {
                    const chosen = filteredPatients[selectedIndex];

                    setPatient(chosen);
                    handlePaymentRequestChange("patientId", chosen.id);
                    handlePaymentRequestChange("visitId", chosen.visit.id);
                    handlePaymentRequestChange("patientName", chosen.fullName);

                    setSearch(`${chosen.id} - ${chosen.fullName}`);
                    setHideResults(true);
                  }
                }}
                sx={{
                  "& .MuiInputBase-root": {
                    height: "40px",
                    fontSize: "14px",
                    background: isSearchEdit ? "#f0f0f0" : "white", // grey background in readOnly mode
                  },
                }}
              />

              {/* Dropdown List */}
              {!hideResults &&
                search.length > 2 &&
                filteredPatients.length > 0 && (
                  <div
                    style={{
                      position: "absolute",
                      top: "45px",
                      left: 0,
                      width: "100%",
                      background: "white",
                      zIndex: 50,
                      border: "1px solid #ddd",
                      borderRadius: "4px",
                      maxHeight: "200px",
                      overflowY: "auto",
                      boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
                    }}
                  >
                    {filteredPatients.map((patient, index) => (
                      <div
                        key={index}
                        className="border-bottom d-flex p-2 cpointer flex-column erpSearchProdElementInnerShadow"
                        onMouseEnter={() => setSelectedIndex(index)}
                        onClick={() => {
                          setPatient(patient);
                          handlePaymentRequestChange("patientId", patient.id);
                          handlePaymentRequestChange(
                            "visitId",
                            patient.visit.id
                          );
                          handlePaymentRequestChange(
                            "patientName",
                            patient.fullName
                          );

                          setSearch(`${patient.id} - ${patient.fullName}`);
                          setHideResults(true);
                        }}
                        style={{
                          cursor: "pointer",
                          background:
                            index === selectedIndex ? "#7bb8f4" : "white", // highlight selection
                        }}
                      >
                        <h6 className="mb-0">
                          {patient.fullName}
                          <span
                            style={{
                              float: "right",
                              fontSize: 13,
                              color: "#444",
                            }}
                          >
                            #{patient.id}
                          </span>
                        </h6>
                      </div>
                    ))}
                  </div>
                )}
            </div>
          </div>

          {/* Amount */}
          <div style={{ flex: 1, minWidth: "140px" }}>
            <TextField
              label="Amount"
              variant="outlined"
              size="small" // <-- THIS MAKES IT SMALL
              type="number"
              inputProps={{ min: 0, step: "any" }}
              value={paymentRequest.requestedAmount}
              onChange={(e) =>
                handlePaymentRequestChange("requestedAmount", e.target.value)
              }
              fullWidth
              required
            />
          </div>

          {/* Request Type */}
          <div style={{ flex: 1, minWidth: "160px" }}>
            <FormControl variant="outlined" fullWidth size="small">
              <InputLabel id="request-type-select-label">
                Request Type
              </InputLabel>

              <Select
                labelId="request-type-select-label"
                value={paymentRequest.type}
                label="Request Type"
                size="small" // <-- SMALL SIZE
                onChange={(e) =>
                  handlePaymentRequestChange("type", e.target.value)
                }
                required
              >
                <MenuItem value={HMS_PAYMENT_REUQEST_TYPE.ADVANCE_REQUEST}>
                  {HMS_PAYMENT_REUQEST_TYPE.ADVANCE_REQUEST}
                </MenuItem>

                <MenuItem value={HMS_PAYMENT_REUQEST_TYPE.REFUND_REQUEST}>
                  {HMS_PAYMENT_REUQEST_TYPE.REFUND_REQUEST}
                </MenuItem>
              </Select>
            </FormControl>
          </div>
          {/* Description */}
          <div style={{ flex: 2, minWidth: "220px" }}>
            <TextField
              label="Description"
              variant="outlined"
              size="small"
              rows={1} // change to 2 if you want more height
              placeholder="Enter description (optional)"
              value={paymentRequest.description || ""}
              onChange={(e) =>
                handlePaymentRequestChange("description", e.target.value)
              }
              fullWidth
            />
          </div>

          <div
            style={{
              /* min-width: 200px; */
              display: "flex",
              gap: "8px",
              alignItems: "center",
              height: "-webkit-fill-available",
            }}
          >
            {/* Buttons */}
            <Button
              type="submit"
              variant="contained"
              startIcon={<Add />}
              sx={{
                backgroundColor: "#1976d2", // Standard MUI primary
                color: "white",
                "&:hover": { backgroundColor: "#1565c0" },
              }}
            >
              ADD
            </Button>
            <Button
              type="button"
              variant="contained"
              startIcon={<Close />}
              onClick={() => closeHMSAddPaymentRequest(false)}
              sx={{
                backgroundColor: "#d32f2f", // Standard MUI error
                color: "white",
                "&:hover": { backgroundColor: "#b71c1c" },
              }}
            >
              CANCEL
            </Button>
          </div>
        </div>
      </form>
    </div>
  );
};

export default AddHMSPaymentRequest;
